import $ from 'jquery';
import React, {Fragment, PureComponent} from 'react';
import I18n from 'app/i18n';
import {localePromoName, scrollToTop, serverError} from 'app/utils';
import TableEmptyState from '../table/empty_state';
import concat from 'lodash/concat';
import ShowMore from 'app/utils/ShowMore';
import SmartLoader from 'app/components/reusable/SmartLoader';
import Prediction from './prediction';

export default class MyPredictions extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            has_more: false,
            loading: true,
            page: 1
        };
        this.loadMoreHandler = this.loadMoreHandler.bind(this);
    }

    componentDidMount = () => {
        this.loadMoreHandler();
        scrollToTop();
    };

    loadMoreHandler() {
        const {page, data} = this.state;

        return $.ajax(window.location.pathname, {
            data: {page},
            error: () => serverError(),
            success: response => this.setState({
                ...response,
                data: concat(data, response.data),
                page: page + 1
            })
        }).always(() => this.setState({loading: false}));
    }

    cancelAnswer = predictionId => {
        const newData = this.state.data.map(predictionData => {
            if (predictionData?.prediction?.id === predictionId) {
                return {
                    ...predictionData,
                    state: 'canceled_by_user'
                };
            }
            return predictionData;
        });
        this.setState({data: newData});
    };

    render() {
        const {data, has_more, loading} = this.state;

        return <Fragment>
            <div className="predictions-title my-prediction">
                <h1 className="title-h1">{I18n.t(`user.promo_action.${localePromoName()}.my_predictions_title`)}</h1>
            </div>
            <div className="compendium">
                {loading
                    ? <SmartLoader/>
                    : <Fragment>
                        <div className="compendium-grid my-prediction">
                            <div className="compendium-grid__items">
                                {data.map(prediction => <Prediction key={prediction.prediction.id}
                                    ref={prediction.prediction.id}
                                    reward={prediction.answer.rating_points}
                                    answerWasGiven={true}
                                    answers={[prediction.answer]}
                                    user_answers={[]}
                                    isMyPredictionPage
                                    cancelAnswer={this.cancelAnswer}
                                    {...prediction}
                                    {...prediction.prediction}/>)}
                            </div>
                        </div>
                        <ShowMore onClickHandler={this.loadMoreHandler} has_more={has_more}/>
                        <TableEmptyState
                            arrayLength={data.length}
                            text={I18n.t(`user.promo_action.${localePromoName()}.you_dont_have_any_predictions_yet`)}
                        />
                    </Fragment>}
            </div>
        </Fragment>;
    }
}
